import React from 'react';
import { Box } from '@mui/material';
import { Swiper } from '@stack/ui/components';

import { CarVideosGalleryProps, NewCarVideo } from '../props';

import VideoImagePopper from './VideoImagePopper';

const CarVideosGallery: React.FC<CarVideosGalleryProps> = ({
  newCarVideosList,
}) => {
  // ======================= HOOKS

  // ======================= VARIABLES
  const getListofVideo = (newCarVideosList?: NewCarVideo) => {
    if (newCarVideosList) {
      return Object.values(newCarVideosList).flatMap((videoList) => videoList);
    }
    return [];
  };

  // ======================= VIEWS
  return (
    <>
      <Swiper
        list={getListofVideo(newCarVideosList)}
        navigation={false}
        isSliderButtonCentered
        allowTouchMove
        pagination={{
          clickable: true,
        }}
        // Whole Box Styling Including Pagination
        style={{
          width: '100%',
          justifyContent: 'space-between',
          flexGrow: 1,
          display: 'flex',
        }}
        // Each individual Video Box
        swiperSlideProps={{
          style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '278px',
            flexGrow: '1',
            overflow: 'hidden',
          },
        }}
        spaceBetween={10}
        height={'156px'}
        renderSlide={(newCarVideosList, index) => (
          <Box sx={{ paddingBottom: '20px' }}>
            <VideoImagePopper key={index} videoUrl={newCarVideosList} />
          </Box>
        )}
        breakpoints={{
          320: {
            slidesPerView: 1.5,
          },
          375: {
            slidesPerView: 2,
          },
          460: {
            slidesPerView: 2.5,
          },
          640: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          800: {
            slidesPerView: 4,
          },
        }}
        slidesPerView={{
          extraSmallMobile: 1.5,
          mobile: 3,
          ipad: 5,
          desktop: 6,
          extraBigScreen: 6,
        }}
      />
    </>
  );
};

export default CarVideosGallery;
